<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Paparan Resit" >

      
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitResit" @success="onSuccess">
    <w-card bg-color="" class="">
        <w-flex justify-center align-center>
          <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No Resit :
                  </h5>
                  <div class="fw-normal my1 fs-1">{{form.no_resit}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Resit :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.tarikh_bayaran}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Status :
                  </h5>
                  <div class="fw-normal my1 fs-1">{{form.resit_status ? form.resit_status.keterangan : '' }} </div>
            </div>
            
        </w-flex>
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Nama :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.profil ? form.profil.no_id: ''}} | {{form.profil ? form.profil.nama: ''}}</div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Alamat :
                  </h5>
                 <!--  <div class="fw-normal my1 fs-1"> {{form.alamat1}}
                    <template v-if="form.alamat2"> , </template> {{form.alamat2}}
                    <template v-if="form.alamat3"> , </template> {{form.alamat3}}
                    <template v-if="form.poskod"> , </template> {{form.poskod}}
                    <template v-if="form.bandar"> , </template> {{form.bandar}}
                    <template v-if="form.negeri"> , </template> {{form.negeri}}</div> -->

                    <div class="fw-normal my1 fs-1"> {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat1 : '' : ''}} ,
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat2 : '' : ''}},
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat3 : '' : ''}},
                    
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_poskod ? form.profil.alamat.lkp_poskod.keterangan : '' : '' : ''}},
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_poskod ? form.profil.alamat.lkp_poskod.bandar : '' : '' : ''}},
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_negeri ? form.profil.alamat.lkp_negeri.keterangan : '' : '' : ''}}
                </div>
            </div>
            <div class="xs4">
                <template v-if="form.lkp_resit_status_id !=1 ">
                  <h5 class="fw-semibold m0">
                      Catatan Batal :
                  </h5>
                  <div class="fw-normal my1 fs-1">{{form.catatan_batal}} </div>
                </template>
            </div>
        </w-flex>
       <!--  <w-flex justify-left align-center>
          <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Alamat :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.alamat1}}
                    <template v-if="form.alamat2"> , </template> {{form.alamat2}}
                    <template v-if="form.alamat3"> , </template> {{form.alamat3}}
                    <template v-if="form.poskod"> , </template> {{form.poskod}}
                    <template v-if="form.bandar"> , </template> {{form.bandar}}
                    <template v-if="form.negeri"> , </template> {{form.negeri}}</div>
            </div>
            <div class="xs4">
              
            </div>
          </w-flex> -->

        <w-flex justify-left align-center>
            <template v-if="form.penyata_pemungut_id == null && form.id > 0">
                <template v-if="kemaskini_resit == 1 && form.is_asal == null">
                    <div class="xs4">
                          <z-lookup :url="service_utiliti +'lookup/cara_bayar'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_cara_bayaran_id"
                            label="Cara Bayaran"        
                          />
                    </div>
                </template>
                <template v-else>
                     <div class="xs4">
                        <z-lookup :url="service_utiliti +'lookup/cara_bayar'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_cara_bayaran_id"
                            label="Cara Bayaran"
                            disabled
                          />
                      </div>
                </template>
            </template>
            <template v-else>
                      <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Cara Bayaran :
                        </h5>
                        <div class="fw-normal my1 fs-1"> {{form.cara_bayaran ? form.cara_bayaran.keterangan : ''}}</div>
                      </div>
            </template>
            <template v-if="form.penyata_pemungut_id == null && form.id > 0">
                <template v-if="kemaskini_resit == 1">
                    <div class="xs4">
                        <z-lookup name="akaun" :url='service_utiliti+"lookup/bank"' 
                        label="Bank" :sort="false" :cache="false" v-model="form.lkp_bank_id" />
                    </div>
                </template>
                <template v-else>
                    <div class="xs4">
                        <z-lookup name="akaun" :url='service_utiliti+"lookup/bank"' 
                        label="Bank" :sort="false" :cache="false" v-model="form.lkp_bank_id" disabled/>
                    </div>
                </template>
            </template>
            <template v-else>
                      <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Bank :
                        </h5>
                        <div class="fw-normal my1 fs-1"> {{form.lkp_bank ? form.lkp_bank.keterangan : ''}}</div>
                      </div>
            </template>
            <template v-if="form.penyata_pemungut_id == null && form.id > 0">

                <template v-if="kemaskini_resit == 1">
                    <div class="xs4">
                        <w-input
                        class="mb4"
                        v-model="form.no_dokumen"
                        label="No Cek / Bank Draf / Transaksi Bank"
                         />
                    </div>
                </template>
                <template v-else>
                     <div class="xs4">
                        <w-input
                        class="mb4"
                        v-model="form.no_dokumen"
                        label="No Cek / Bank Draf / Transaksi Bank"
                        disabled
                         />
                    </div>
                </template>
            </template>
            <template v-else>
                      <div class="xs4">
                        <h5 class="fw-semibold m0">
                            No Cek / Bank Draf / Transaksi Bank :
                        </h5>
                        <div class="fw-normal my1 fs-1"> {{form.no_dokumen}}</div>
                      </div>
              </template>
          </w-flex>
    </w-card>

    
    <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>

    <w-tabs :items="tabs" :no-slider="false" active-class="primary">  
    <template #item-content.1> 

              <w-flex justify-center align-center class="mt5">
              <div class="w-card__content content-hardcode">                
                <table class="table-dashboard" style="table-layout: fixed; width: 100%">
                    <thead>
                        <tr>
                            <td width="20%">KOD HASIL</td>
                            <td width="20%">VOT</td>
                            <td width="45%">BUTIRAN</td>
                            <td width="15%">AMAUN BAYARAN (RM)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dt, index in form.butiran">
                            <td >
                                <template v-if="form.penyata_pemungut_id == null && form.id > 0 && form.lkp_resit_status_id !=2 && form.is_asal == null">
                                    <template v-if="kemaskini_resit == 1">
                                        <!-- <z-lookup name="akaun" :url='service_utiliti+"lookup/akaun_akhir"'  :sort="false" :cache="false" v-model="dt.akaun_id" /> -->
                                         <z-lookup name="akaun" :url='service_utiliti+"lookup/akaun_akhir_vot"' :sort="false" :cache="false" v-model="dt.akaun_id" @pilih="Vot_akaun(dt)" :validators="[validators.required]"/>
                                     </template>
                                     <template v-else>
                                         <z-lookup name="akaun" :url='service_utiliti+"lookup/akaun_akhir_vot"' :sort="false" :cache="false" v-model="dt.akaun_id" @pilih="Vot_akaun(dt)" :validators="[validators.required]" disabled/>
                                     </template>
                                </template>
                                <template v-else>
                                      {{dt.akaun.kod}} | {{dt.akaun.keterangan}}
                                </template>
                            </td>
                           <td>
                                <template v-if="form.penyata_pemungut_id == null && form.id > 0 && form.lkp_resit_status_id !=2 && form.is_asal == null">

                                    <template v-if="kemaskini_resit == 1">
                                       <template v-if="dt.vot_id">
                                            <template v-if="dt.ind_vot_id">
                                               <z-lookup name="vot" :url='service_bil_pelbagai+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                            </template>
                                            <template v-else>
                                               <z-lookup name="vot" :url='service_bil_pelbagai+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                            </template>
                                       </template>
                                       <template v-else>
                                            <z-lookup name="vot" :url='service_bil_pelbagai+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                       </template>
                                    </template>
                                    <template v-else>
                                            <z-lookup name="vot" :url='service_bil_pelbagai+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  disabled/>
                                   </template>
                                </template>
                                <template v-else>
                                      {{dt.vot.kod}} <template v-if="dt.vot_kod"> | </template> {{dt.vot.keterangan}}
                                </template>
                             </td>
                             <td >
                                <div style="word-wrap: break-word;">
                                     {{dt.keterangan}}
                                 </div>
                            </td>
                            <td align="right">
                                {{$zutil.currency(dt.amaun)}}
                            </td>
                           
                        </tr>
                        <tr >
                          <td colspan="3" align="right"><b>Jumlah</b></td>
                          <td align="right"><b>{{$zutil.currency(form.amaun)}}</b></td>
                          
                          <!-- <td>{{$zutil.currency(form.kuantiti)}}</td> -->
                        </tr>
                        
                        
                    </tbody>
                </table>
              </div>

            </w-flex>
             <w-flex class="mt3" wrap align-center justify-end>

                <template v-if="form.penyata_pemungut_id == null && form.id > 0 && form.lkp_resit_status_id !=2 && kemaskini_resit == 1">
                    <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                        <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
                    </w-button>
                    &nbsp;&nbsp; 
                    <w-button class="my1" bg-color="error-dark1" dark  @click="TutupResit()" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon>Batal Kemaskini
                    </w-button>
                </template>

                <!-- <template  v-if="form.lkp_resit_status_id == 1 && form.tarikh_batal == null && form.status_kaunter == 1 && form.tarikh_resit == form.tarikh && $zutil.can('Resit Batal')"> -->
                    <!-- <template  v-if="form.lkp_resit_status_id == 1 && form.tarikh_batal == null && form.penyata_pemungut_id == null && form.tarikh_resit == form.tarikh && $zutil.can('Resit Batal')"> -->

                <template v-if="kemaskini_resit == 0">
                        <template v-if="form.penyata_pemungut_id == null && form.id > 0 && form.lkp_resit_status_id !=2 && form.is_asal == null">
                            <w-button class="my1" bg-color="primary" dark @click="KemaskinilResit()" >
                                 <w-icon dark tile class="mr2">fal fa-edit</w-icon> Kemaskini
                            </w-button> 
                            &nbsp;&nbsp;
                        </template>
                        <template  v-if="form.lkp_resit_status_id == 1 && form.penyata_pemungut_id == null && $zutil.can('Resit Batal')">

                            <w-button class="my1" bg-color="error-dark1" dark  @click="BatalResit()" >
                                 <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                            </w-button>
                            &nbsp;&nbsp;
                            <!-- <w-button bg-color="success" class="mr3" @click="cetak()">
                                <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                            </w-button> -->
                      </template>
                      <template v-if="form.lkp_resit_status_id == 3">
                            <w-button class="my1" bg-color="success" dark  @click="send(1)" >
                                 <w-icon dark tile class="mr2">fal fa-times</w-icon> Tidak Lulus
                            </w-button>
                            &nbsp;&nbsp;
                        </template>
                      <!-- <template v-if="form.lkp_resit_status_id == 3 && form.penyata_pemungut_id == null && form.tarikh_resit == form.tarikh && $zutil.can('Kelulusan Batal Resit')"> -->
                      <template v-if="form.lkp_resit_status_id == 3 && form.penyata_pemungut_id == null && $zutil.can('Kelulusan Batal Resit')">
                            <w-button class="my1" bg-color="primary" dark  @click="send(2)" >
                                 <w-icon dark tile class="mr2">fal fa-save</w-icon> Lulus
                            </w-button>
                                &nbsp;&nbsp;
                      </template>
                        <template v-if="form.kaunter_id == 1">
                             <w-button class="my1" bg-color="warning" dark  @click="kembali_ibayaq()" >
                                 <w-icon dark tile class="mr2">fal fa-times</w-icon> Kembali
                            </w-button>
                        </template>
                        <template v-else-if="form.is_kiosk == 1">
                             <w-button class="my1" bg-color="warning" dark  @click="kembali_kiosk()" >
                                 <w-icon dark tile class="mr2">fal fa-times</w-icon> Kembali
                            </w-button>
                        </template>
                        <template v-else>
                             <w-button class="my1" bg-color="warning" dark  @click="kembali()" >
                                 <w-icon dark tile class="mr2">fal fa-times</w-icon> Kembali
                            </w-button>
                        </template>

                        <template v-if="form.is_manual != 1">
                            &nbsp;

                            <template v-if="form.is_asal == null">
                                <w-button bg-color="success" class="mr3" @click="CetakResit()">
                                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak Asal
                                </w-button>
                            </template>
                            <template v-else>
                                <w-button bg-color="success" class="mr3" @click="cetak()">
                                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak Salinan
                                </w-button>
                             </template>
                            &nbsp;
                            <w-button bg-color="success" class="mr3" @click="cetak_pejabat()">
                                <w-icon>fal fa-print</w-icon>&nbsp;Cetak Salinan Pejabat
                            </w-button>
                        </template>
                </template>
            </w-flex>
        </template>
        <template #item-content.2>
            <!-- <z-jejak-audit :jejak_audit="form.jejak_audit"/> -->
            <w-flex justify-center align-center>
          <div class="w-card__content content-hardcode">

              <table class="table-dashboard" width="100%">
                  <thead>
                  <tr>
                      <td >No</td>
                      <td >Tindakan</td>
                      <td >Pengguna</td>
                      <td >Tarikh</td>
                      <td>Catatan</td>
                  </tr>
                  </thead>
                  <tbody>
                  
                      <tr v-for="dt, index in form.jejak_audit">
                          <td class="w-table__cell text-left">
                              {{(index + 1)}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.tindakan_resit.keterangan}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.user.name}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{$zutil.dateformat(dt.created_at)}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.catatan}}
                          </td>
                      </tr>
                      <tr v-if="form.jejak_audit.length == 0">
                          <td class="w-table__cell text-left" colspan="5">
                          </td>
                      </tr>
                  </tbody>
                  
              </table>
            </div>
          </w-flex>
        </template>

    </w-tabs>
             

        </w-form>

     
     
  
    </z-page>
    <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Permohonan Batal Resit
            </template>
            <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess"> 
               <w-flex justify-space-between class="mb4">
                   <z-input 
                        label="Catatan Batal *"  
                        name="catatan_batal" 
                        v-model="form.catatan_batal"
                        :validators="[validators.required]"/>
              </w-flex>
            </w-form>
            

            <template #actions>
                <div class="spacer" />

                <template v-if="form.catatan_batal != null">
                  <w-button class="my1" bg-color="primary"  dark :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(3)" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Hantar
                  </w-button>
              </template>
                    &nbsp;&nbsp;
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

         <w-dialog
              v-model="dialogCetak.show"
              :fullscreen="dialogCetak.fullscreen"
              :width="dialogCetak.width"
              :persistent="dialogCetak.persistent"
              :persistent-no-animation="dialogCetak.persistentNoAnimation"
              title-class="primary-light1--bg white">
            <template #title>
               Adakah anda pasti untuk cetak?<br> Pastikan jenis bayaran dan semua maklumat telah betul sebelum dicetak.  
               <br>
            </template>
       
        <w-flex justify-center align-center>
          <div class="xs3">
                 <w-button bg-color="success"  @click="cetak()">
                        Ya           
                    </w-button>
                </div>
          <div class="xs3">
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialogCetak.show = false"
                    >Tidak</w-button
                >
            </div>
        </w-flex>
            <!-- <template #actions>
                <div class="spacer" />

                  
            </template> -->
        </w-dialog>

  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
    resourceurl: this.service_kutipan +'resit',
    loading : true,
    reload: true,

        akauns : [],
          form: {
                    lkp_bank_id : '',
                },

    kemaskini_resit: '',
    dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
            },

    dialogCetak: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 400,
            },

         validators: {
                unique: (value) => !!value || "Medan Ini Wajib Isi",
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },

      
    
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Resit', route: '/resit' },
        { label: 'Papar', route: '/resit/'+this.id },
      ],
       tabs: [
          { title: 'Senarai Butiran', content: '' },
          { title: 'Jejak Audit', content: '' },
      ],
    }
  },
    methods: {

    // addItem() {
    //     this.form.butiran.push( {akaun_id : null, no_fail : null, keterangan : [null], kuantiti : 1, kadar : null, amaun : null});
    // },


    send(status){

     // alert(status);
      this.form.lkp_resit_status_id = status
      this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }

                    if (this.form.kaunter.is_kiosk == 1) {
                        this.$inertia.visit(this.$route('kutipan.resit.senarai_kiosk'))
                    }else if (this.form.kaunter_id == 1) {
                        this.$inertia.visit(this.$route('kutipan.resit.senarai_ibayaq'))
                    }else{
                        this.$inertia.visit(this.$route('kutipan.resit.index'))
                    }
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    
    },
   submitResit(){
     // alert('asssd');
        if (this.form.id > 0) {
            this.form.kemas_kini = 1
              this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      
                     this.kemaskini_resit = 0;

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      
                        window.location.reload();
                      // this.load();

                        // this.$inertia.visit(this.$route('kutipan.resit.show', this.form.id))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
          }
    },
   
   kembali(){
         this.$inertia.visit(this.$route('kutipan.resit.index'))
    },

    kembali_ibayaq(){
         this.$inertia.visit(this.$route('kutipan.resit.senarai_ibayaq'))
    },
    kembali_kiosk(){
         this.$inertia.visit(this.$route('kutipan.resit.senarai_kiosk'))
    },
   
    
    cetak(id) {
        
            // window.location.href = this.service_bil_pelbagai+'api/inbois/cetak'+id;
            window.location.href = this.service_kutipan+'resit/cetak/'+this.id;
              //   this.$swal({
              //   title: 'Anda Pasti?',
              //   type: 'warning',
              //   showCancelButton: true,
              //   confirmButtonColor: '#3085d6',
              //   cancelButtonColor: '#d33',
              //   confirmButtonText: 'Ya',
              //   cancelButtonText: 'Tidak'
              // }).then((result) => {
              //   if (result.value) {
                    
              //       window.location.href = this.service_kutipan+'resit/cetak/'+this.id;
                
              //    }else{
              //   }
              // })

            this.dialogCetak.show = false
        },

    cetak_pejabat(id) {
            // window.location.href = this.service_bil_pelbagai+'api/inbois/cetak'+id;
            window.location.href = this.service_kutipan+'resit/cetak/'+this.id+'?pejabat='+1;
        },

     BatalResit() {
            this.dialog.show = 1;
        },

    CetakResit() {
        this.dialogCetak.show = 1;
    },
    getAkauns() {
      
      this.$zcomm.get(this.service_utiliti+'lookup/akaun_akhir_vot').then(res => {
              this.akauns = res;
            });
    },

    Vot_akaun(dt){
    
        if(dt.ind_vot_id == 0){
            dt.ind_vot_id = 1
        }else{
            dt.ind_vot_id = 0
        }
        for (var a in this.akauns) {
            if(dt.akaun_id == this.akauns[a].value){
                dt.vot_id = this.akauns[a].vot;
            }
        }
     },

    // load()  {
    //       var app = this;
    //       if(this.id){
    //         if(this.id > 0){
    //           this.$zcomm.get(this.service_kutipan +'resit/'+this.id+''+window.location.search).then(res => {
    //             // this.form = res;

    //           })
    //           .finally(() => {
    //             this.loading = false
    //           });
    //         }
    //       }
    // },

    KemaskinilResit()  {
        this.kemaskini_resit = 1;
    },

    TutupResit()  {
        this.kemaskini_resit = 0;
    },

    
  },
  watch: {

  },
  mounted() {

    this.kemaskini_resit = 0;
    // this.load();
    this.getAkauns();
    if(this.id == 0){
      this.form = {
        show: true,
        butiran : [{akaun_id : null, no_fail : null, keterangan : null, kuantiti : 1, kadar : null, amaun : null} ]}
      }
    
      
  },
    
}
</script>